import React from 'react'

import type { CSSObject } from '@emotion/serialize'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

import Typography from 'components/Template/MuiTypography'
import { imageSettingStyles } from 'pages/Listen/styles'

const StyledIconButton = styled(IconButton)(imageSettingStyles)

export interface ImageCropperProps {
    className?: string
    cropper: React.ReactNode
    slider: React.ReactNode
    triggerImageCrop: () => void
    handleCropCanceled: () => void
}

function UnstyledImageCropper({ className, cropper, slider, triggerImageCrop, handleCropCanceled }: ImageCropperProps) {
    return (
        <div className={className}>
            <div className='crop-container'>{cropper}</div>
            <div className='control-buttons'>
                <StyledIconButton aria-label='confirm-crop' onClick={triggerImageCrop} size='large'>
                    <CheckIcon />
                </StyledIconButton>
                <StyledIconButton aria-label='cancel-crop' onClick={handleCropCanceled} size='large'>
                    <ClearIcon />
                </StyledIconButton>
            </div>
            <div className='slider-container'>
                <Typography style={{ marginRight: '10px' }}>Zoom</Typography>
                {slider}
            </div>
        </div>
    )
}

const imageCropperStyles = {
    position: 'relative',
    width: '100%',
    height: '100%',
    '& .crop-container': {
        position: 'relative',
        width: '100%',
        height: '100%',
        background: '#333'
    },
    '& .control-buttons': {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: 16,
        display: 'flex',
        alignItems: 'center'
    },
    '& .slider-container': {
        position: 'absolute',
        bottom: '5%',
        left: '10%',
        width: '80%',
        display: 'flex',
        flex: '1',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '5px',
        padding: '10px'
    }
} as CSSObject

const ImageCropper = styled(UnstyledImageCropper)(imageCropperStyles)
export default ImageCropper
